// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { precisionM } from 'config/constants'
import { convertBetweenMandFt } from 'helpers/unitConversion'

import {
  castToFloat,
  roundToFixed,
} from 'helpers/reduxFormFunctions'

const createMetersAndFeetString = value => (
  castToFloat(value) !== null
    ? `${roundToFixed(value, precisionM)}m / ${convertBetweenMandFt(value, 'US')}ft`
    : 'N/A'
)

export default createMetersAndFeetString
